import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { getRestEndpoint } from 'src/app/helpers/api-url';

import {
  IPasswordRegex,
  IPasswordValidatorsAndText,
  IPaswordConfig,
} from '../../interfaces/password/password.interface';

@Injectable({
  providedIn: 'root',
})
export class PasswordService {
  constructor(private http: HttpClient) {}

  getPasswordConfig(): Observable<IPaswordConfig> {
    return this.http.get<IPaswordConfig>(
      `${getRestEndpoint()}/configurations/passwords`,
    );
  }

  getPasswordConfigRegex(): Observable<IPasswordRegex> {
    return this.http.get<IPasswordRegex>(
      `${getRestEndpoint()}/configurations/passwords/regex`,
    );
  }

  getPasswordValidatorsAndText(): Observable<IPasswordValidatorsAndText> {
    return combineLatest([
      this.getPasswordConfig(),
      this.getPasswordConfigRegex(),
    ]).pipe(
      map(([configResponse, regexResponse]) => {
        const text = this.getPasswordRequirmentsText(configResponse);
        const config = { ...configResponse, ...regexResponse };
        return {
          text,
          config,
        };
      }),
    );
  }

  private getPasswordRequirmentsText(config: IPaswordConfig): string {
    let text = 'Password should match next requirements:';

    if (config.minimumLength) {
      text += `\r\nMinimum length: ${config.minimumLength}`;
    }
    if (config.maximumLength) {
      text += `\nMaximum length: ${config.maximumLength}`;
    }
    if (config.numberIdenticalCharsInRow) {
      text += `\nNumber of identical characters in row: ${config.numberIdenticalCharsInRow}`;
    }
    if (config.requireLowercase) {
      text += `\nRequire lowercase letter`;
    }
    if (config.requireNumeric) {
      text += `\nRequire numeric character`;
    }
    if (config.requireUppercase) {
      text += `\nRequire uppercase letter`;
    }
    if (config.specialCharacters) {
      text += `\nRequire special character`;
    }
    return text;
  }
}
